import type { RankingRow } from "../../types/ranking";

type Props = {
    rows: RankingRow[];
};

export default function MiniRanking({ rows }: Props) {
    return (
        <aside className="overflow-hidden rounded-2xl border border-white/10 bg-[#0d121b]">
            <div className="border-b border-white/10 bg-[#131a25] px-5 py-4">
                <h3 className="text-xl font-black uppercase text-white">Classement</h3>
            </div>

            <div className="grid grid-cols-[40px_1fr_55px_55px] px-5 py-3 text-xs font-black uppercase tracking-wide text-white/45">
                <span>#</span>
                <span>Club</span>
                <span>Pts</span>
                <span>J</span>
            </div>

            {rows.map((row) => (
                <div
                    key={row.id}
                    className="grid grid-cols-[40px_1fr_55px_55px] items-center border-t border-white/10 px-5 py-4"
                >
                    <span className="text-sm font-black text-[#e5ff00]">{row.position}</span>

                    <div className="flex items-center gap-3">
                        <img
                            src={row.teamLogo}
                            alt={row.teamName}
                            className="h-8 w-8 rounded-full object-cover"
                        />
                        <span className="text-sm font-bold text-white">{row.teamName}</span>
                    </div>

                    <span className="text-sm font-black text-white">{row.points}</span>
                    <span className="text-sm text-white/75">{row.played}</span>
                </div>
            ))}

            <div className="border-t border-white/10 px-5 py-4">
                <button className="text-sm font-black uppercase tracking-wide text-[#e5ff00] transition hover:text-[#ff7a00]">
                    Voir le classement complet
                </button>
            </div>
        </aside>
    );
}